import { Box, Typography } from '@mui/material';
import { HMILogEntry } from '../types';

const LEVEL_COLOR: Record<HMILogEntry['level'], string> = {
  INFO: '#455A64',
  WARN: '#ED6C02',
  ERROR: '#D32F2F',
};

export interface LogViewerProps {
  logs: HMILogEntry[];
}

/**
 * Illustrative event log for the "Log" screen. Not part of the UI_fields
 * spreadsheet schema (no rows use `screen: "log"` yet) - included to show how
 * BMT events would be surfaced once question #7 ("how logs are sent to
 * PEPsense via GET API") is answered; see the docs for the proposed contract.
 */
function LogViewer({ logs }: LogViewerProps) {
  return (
    <Box
      sx={{
        fontFamily: 'monospace',
        fontSize: 13,
        maxHeight: 480,
        overflowY: 'auto',
        bgcolor: '#0f172a',
        color: '#e2e8f0',
        p: 2,
        borderRadius: 1,
      }}
    >
      {logs.length === 0 && <Typography variant="body2">No log entries yet.</Typography>}
      {[...logs].reverse().map((entry, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={idx} sx={{ mb: 0.5 }}>
          <span style={{ color: '#64748b' }}>
            {new Date(entry.timestamp).toLocaleTimeString()}
          </span>{' '}
          <span style={{ color: LEVEL_COLOR[entry.level], fontWeight: 700 }}>
            [{entry.level}]
          </span>{' '}
          <span>{entry.message}</span>
        </Box>
      ))}
    </Box>
  );
}

export default LogViewer;
